module.exports = __webpack_public_path__ + "static/media/job-bg.9c29c2f6.png";